<template>
  <cardTemplate
    :classCustom="'detail detail-notify notification margin-bottom-10'"
  >
    <template #content>
      <div class="header flex-row flex__left">
        <div class="margin-right-10">
          <img src="../../assets/img/bellNoti.svg"/>
        </div>
        <div
          class="rightSection width__100 padding-bottom-10 has-border__bottom"
        >
          <h3 class="tt1">{{ cardTitle }}</h3>
          <span class="tt2">
            <span class="font-size__small"> {{ notifysCount }} thông báo</span>
            &nbsp;
            <el-tag type="success" class="priority" size="mini"
            >{{ unreadNotifysCount }} mới</el-tag
            >
          </span>
        </div>
      </div>
      <div class="body">
        <VuePerfectScrollbar
          class="scroll-body-notify"
          :settings="perfectScrollbarSetting"
        >
          <div class="list-notify">
            <div
              @click="viewDetailV2(item)"
              :class="[
                'ele-notify flex-row flex-left__top clickable',
                item.status === 'unSeen' ? 'read' : ''
              ]"
              v-for="item in notifis"
              :key="item.notificationDetailId"
            >
              <div class="avatar_fake flex-row flex__center margin-right-10">
                <span class="font-size__small">{{
                  buildShortName(item.fromUserName)
                }}</span>
              </div>
              <div
                class="content-main width__100 padding-bottom-10 has-border__bottom"
              >
                <el-tag type="" size="mini" class="roleLabel">
                  {{ buildDeptRoleLabel(item) }}
                </el-tag>
                <notification-item-cv
                  :vbNotificationView="item"
                  v-if="isCVNotification(item)"
                ></notification-item-cv>
                <notification-item-quahan-cv
                  :vbNotificationView="item"
                  v-else-if="item.messageType === MESSAGE_TYPE.CV_CANHBAOQUAHAN"
                ></notification-item-quahan-cv>
                <notification-item-vb
                  :vbNotificationView="item"
                  v-else-if="isVbNotificationV2(item)"
                ></notification-item-vb>
                <notification-item-banhanhtoi
                  :vbNotificationView="item"
                  v-else-if="item.messageType === MESSAGE_TYPE.INCOMING_BANHANH"
                ></notification-item-banhanhtoi>
                <notification-item-ranking-score
                  :vbNotificationView="item"
                  v-else-if="
                    item.messageType === MESSAGE_TYPE.RANKING_INSERTRANKINGSCORE
                  "
                ></notification-item-ranking-score>

                <notification-item-hc-commands
                  :vbNotificationView="item"
                  v-else-if="
                    item.messageType === MESSAGE_TYPE.CHI_DAO.BAO_CAO ||
                      item.messageType === MESSAGE_TYPE.CHI_DAO.GIA_HAN ||
                      item.messageType === MESSAGE_TYPE.CHI_DAO.DK_DEADLINE
                  "
                ></notification-item-hc-commands>

                <notification-item-hc-commands-common
                  :vbNotificationView="item"
                  v-else-if="
                    item.messageType === MESSAGE_TYPE.CHI_DAO.CREATE ||
                      item.messageType === MESSAGE_TYPE.CHI_DAO.UPDATE ||
                      item.messageType === MESSAGE_TYPE.CHI_DAO.YCBS ||
                      item.messageType === MESSAGE_TYPE.CHI_DAO.HUY ||
                      item.messageType === MESSAGE_TYPE.CHI_DAO.PHE_DUYET ||
                      item.messageType === MESSAGE_TYPE.CHI_DAO.CHO_Y_KIEN
                  "
                ></notification-item-hc-commands-common>

                <notification-item-hc-dieuxe
                  :vbNotificationView="item"
                  v-else-if="
                    item.messageType === MESSAGE_TYPE.DIEU_XE.DANG_KY ||
                      item.messageType === MESSAGE_TYPE.DIEU_XE.PHE_DUYET ||
                      item.messageType === MESSAGE_TYPE.DIEU_XE.TU_CHOI ||
                      item.messageType === MESSAGE_TYPE.DIEU_XE.HUY_YEU_CAU ||
                      item.messageType === MESSAGE_TYPE.DIEU_XE.CAP_NHAT
                  "
                ></notification-item-hc-dieuxe>

                <notification-item-hc-case-flight
                  :vbNotificationView="item"
                  v-else-if="
                    item.messageType === MESSAGE_TYPE.MAY_BAY.DANG_KY ||
                      item.messageType === MESSAGE_TYPE.MAY_BAY.PHE_DUYET ||
                      item.messageType === MESSAGE_TYPE.MAY_BAY.TU_CHOI ||
                      item.messageType === MESSAGE_TYPE.MAY_BAY.HUY_YEU_CAU ||
                      item.messageType === MESSAGE_TYPE.MAY_BAY.CAP_NHAT
                  "
                ></notification-item-hc-case-flight>

                <notification-item-hc-case-hotel
                  :vbNotificationView="item"
                  v-else-if="
                    item.messageType === MESSAGE_TYPE.KHACH_SAN.DANG_KY ||
                      item.messageType === MESSAGE_TYPE.KHACH_SAN.PHE_DUYET ||
                      item.messageType === MESSAGE_TYPE.KHACH_SAN.TU_CHOI ||
                      item.messageType === MESSAGE_TYPE.KHACH_SAN.HUY_YEU_CAU ||
                      item.messageType === MESSAGE_TYPE.KHACH_SAN.CAP_NHAT
                  "
                ></notification-item-hc-case-hotel>

                <notification-item-hc-case-phonghop
                  :vbNotificationView="item"
                  v-else-if="
                    item.messageType === MESSAGE_TYPE.PHONG_HOP.DANG_KY ||
                      item.messageType === MESSAGE_TYPE.PHONG_HOP.PHE_DUYET ||
                      item.messageType === MESSAGE_TYPE.PHONG_HOP.TU_CHOI ||
                      item.messageType === MESSAGE_TYPE.PHONG_HOP.HUY_YEU_CAU ||
                      item.messageType === MESSAGE_TYPE.PHONG_HOP.CAP_NHAT
                  "
                ></notification-item-hc-case-phonghop>

                <notification-item-hc-case-scn
                  :vbNotificationView="item"
                  v-else-if="
                    item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.DANG_KY ||
                      item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.PHE_DUYET ||
                      item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.TU_CHOI ||
                      item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.HUY_YEU_CAU ||
                      item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.CAP_NHAT
                  "
                ></notification-item-hc-case-scn>

                <div v-else v-html="handleAction(item.messageType, item)"></div>
                <div class="moreInfo">
                  <div class="time no_wrap flex-row">
                    <i class="font-size__small fal fa-clock"></i>
                    &nbsp;{{ item.createTime | convertToLabelFilter }}&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
    </template>
  </cardTemplate>
</template>

<script>
  import utils from "../../services/utils";
  import convertToLabelFilter from "../../filters/convertToLabelFilter.js";
  import constants from "../../constants";
  import vbNotificationService from "../../services/vbNotificationService";
  import moment from "moment";
  import NotificationItemCv from "../../components/header/notification-item-cv";
  import NotificationItemVb from "../../components/header/notification-item-vb";
  import notificationMixin from "../../mixins/notificationMixin";
  import NotificationItemQuahanCv from "../../components/header/notification-item-quahan-cv";
  import NotificationItemBanhanhtoi from "../../components/header/notification-item-banhanhtoi";
  import NotificationItemRankingScore from "../../components/header/notification-item-ranking-score";

  export default {
    name: "NotifyCard",
    mixins: [notificationMixin],
    props: ["cardTitle", "notifis", "notifysCount", "unreadNotifysCount"],
    components: {
      NotificationItemRankingScore,
      NotificationItemBanhanhtoi,
      NotificationItemQuahanCv,
      NotificationItemVb,
      NotificationItemCv,
      cardTemplate: () => import("../common/cardTemplate.vue"),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
    },
    filters: {convertToLabelFilter},
    data() {
      return {
        perfectScrollbarSetting: {maxScrollbarLength: 350},
        MESSAGE_TYPE: constants.VB_NOTIFICATION.MESSAGE_TYPE
      };
    },
    computed: {
      userDeptRoles() {
        return this.$store.getters.userDeptRoles;
      }
    },
    methods: {
      handleAction(action, object) {
        if (!object) return;
        switch (action) {
          case "chuyenXuLy":
            return this.buildCXL(object);
          case "chuyenTiep":
            return this.buildCXL(object);
          case "thuHoi":
            return this.buildTuChoi(object);
          case "ketThuc":
            return this.buildTuChoi(object);
          case "tuChoi":
            return this.buildTuChoi(object);
          case "tuChoiBanHanh":
            return this.buildTuChoi(object);
          case "banhanh":
            return this.buildBHanh(object);
          case "CC":
            return this.buildChuyenTiep(object);
          case "choBanHanh":
            return this.buildTuChoi(object);
          case "tuChoiTiepNhan":
            return this.buildTuChoiTiepNhan(object);
          case "chuyenTiepLanhDao":
            return this.buildChuyenTiep(object);
          default:
            return object.messageType;
        }
      },

      buildTuChoi(object) {
        return (
          "<div" +
          '        class=""' +
          "      >" +
          "        <span>Ông/bà</span>" +
          "        <span" +
          '          class="highlight font-weight__bold"' +
          "        >" +
          object.fromUserName +
          "        </span>" +
          "        <span>đã</span>" +
          "        <span" +
          '          class="highlight-action"' +
          "        >" +
          this.getActionText(object.messageType) +
          "        </span>" +
          "        <span> văn bản </span>" +
          '        <span class="event ">"' +
          this.buildQuote(object) +
          '"</span>' +
          "      </div>"
        );
      },

      buildCXL(object) {
        return (
          "<div" +
          '        class=""' +
          "      >" +
          "        <span>Ông/bà</span>" +
          "        <span" +
          '          class="highlight font-weight__bold"' +
          "        >" +
          object.fromUserName +
          "        </span>" +
          "        <span>đã</span>" +
          "        <span" +
          '          class="highlight-action"' +
          "        >" +
          this.getActionText(object.messageType) +
          "        </span>" +
          "        <span> văn bản </span>" +
          '        <span class="event ">"' +
          this.buildQuote(object) +
          '"</span>' +
          "      </div>"
        );
      },

      buildBHanh(object) {
        return (
          "<div" +
          '        class=""' +
          "      >" +
          "        <span>" +
          "         <strong>" +
          object.fromUserName +
          "</strong> " +
          "        <span" +
          '          class="highlight-action"' +
          "        >" +
          this.getActionText(object.messageType) +
          "        </span>" +
          "         văn bản <strong>" +
          (this.dataJson(object).object.docCode
            ? "số " + this.dataJson(object).object.docCode
            : "") +
          "</strong> ngày <strong>" +
          this.formatDate(this.dataJson(object).object.docDate) +
          "</strong>" +
          "        </span>" +
          "        <span> về việc </span>" +
          '        <span class="event ">"' +
          this.buildQuote(object) +
          '"</span>' +
          "      </div>"
        );
      },

      buildTuChoiTiepNhan(object) {
        return (
          "<div" +
          '        class=""' +
          "      >" +
          "        <span>" +
          "         <strong>" +
          object.fromUserName +
          "</strong> " +
          "        <span" +
          '          class="highlight-action"' +
          "        >" +
          this.getActionText(object.messageType) +
          "        </span>" +
          "         văn bản " +
          "         <strong>" +
          (this.dataJson(object).object.docCode
            ? "số " + this.dataJson(object).object.docCode
            : "") +
          "</strong>" +
          "         ngày " +
          "         <strong>" +
          this.formatDate(this.dataJson(object).object.docDate) +
          "</strong>" +
          "        </span>" +
          "        <span> về việc </span>" +
          '        <span class="event ">"' +
          this.buildQuote(object) +
          '"</span>' +
          "      </div>"
        );
      },

      buildChuyenTiep(object) {
        return (
          "<div" +
          '        class="content"' +
          "      >" +
          "        <span>" +
          "         <strong>" +
          object.fromUserName +
          "</strong> " +
          "        <span" +
          '          class="highlight-action"' +
          "        >" +
          this.getActionText(object.messageType) +
          "        </span>" +
          "        văn bản <strong>" +
          (this.dataJson(object).object.docCode
            ? "số " + this.dataJson(object).object.docCode
            : "") +
          "</strong> ngày <strong>" +
          this.formatDate(this.dataJson(object).object.docDate) +
          "</strong>" +
          "        </span>" +
          "        <span> về việc </span>" +
          '        <span>"' +
          this.dataJson(object).object.quote +
          '"</span>' +
          "      </div>"
        );
      },

      formatDate(value) {
        let date = new moment(value);
        return date.format("DD/MM/YYYY");
      },

      dataJson(item) {
        return JSON.parse(item.dataJson);
      },

      buildQuote(item) {
        let info = JSON.parse(item.dataJson);
        return info.object.quote;
      },

      buildShortName(fullName) {
        return utils.buildShortName(fullName);
      },

      getActionText(action) {
        switch (action) {
          case "chuyenXuLy":
            return "Chuyển xử lý";
          case "chuyenTiep":
            return "Chuyển tiếp";
          case "thuHoi":
            return "Thu hồi";
          case "ketThuc":
            return "Ký duyệt";
          case "tuChoi":
            return "Từ chối";
          case "tuChoiBanHanh":
            return "Từ chối ban hành";
          case "banhanh":
            return "Ban hành";
          case "choBanHanh":
            return "Ký duyệt";
          case "CC":
            return "CC văn bản";
          case "chuyenTiepLanhDao":
            return "Chuyển tiếp";
          case constants.ACTION_LOG_ACTION_NAME.TUCHOITIEPNHAN:
            return "Từ chối tiếp nhận";
          case constants.ACTION_LOG_ACTION_NAME.LANHDAO_TUCHOI:
            return "Từ chối";
          default:
            return "";
        }
      },

      buildDeptRoleLabel(item) {
        let _item = item;
        return `${_item.toRoleName} ${_item.toDeptName}`;
      },

      viewDetailV2(item) {
        switch (item.messageType) {
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.CREATE:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.UPDATE:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.PHE_DUYET:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.HUY:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.YCBS:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.DK_DEADLINE:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.GIA_HAN:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.BAO_CAO:
            this.viewHcCommandsDetail(item);
            break;
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.CAP_NHAT:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.HUY_YEU_CAU:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.TU_CHOI:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.PHE_DUYET:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.DANG_KY:
            this.viewHcDieuXeDetail(item);
            break;
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.CAP_NHAT:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.HUY_YEU_CAU:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.TU_CHOI:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.PHE_DUYET:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.DANG_KY:
            this.viewHcCaseFlightDetail(item);
            break;
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.CAP_NHAT:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.HUY_YEU_CAU:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.TU_CHOI:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.PHE_DUYET:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.DANG_KY:
            this.viewHcCaseHotelDetail(item);
            break;
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.CAP_NHAT:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.HUY_YEU_CAU:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.TU_CHOI:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.PHE_DUYET:
          case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.DANG_KY:
            this.viewHcCasePhongHopDetail(item);
            break;
          default:
            this.viewDetail(item);
        }
      },

      viewDetail(item) {
        if (this.isViewTaskDetail(item)) this.viewTaskDetail(item);
        else if (
          this.isVbNotificationV2(item) ||
          item.messageType ===
          constants.VB_NOTIFICATION.MESSAGE_TYPE.INCOMING_BANHANH
        ) {
          this.viewDocDetailV2(item);
        } else this.viewDocDetail(item);
      },

      maskAsSeen(item) {
        item.status = "seen";
        vbNotificationService.maskAsSeen(item);
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/NotifyCard.vue